"use client";

import { c as _c } from "react/compiler-runtime";
import ProductGallery from "./ProductGallery";
import ProductBrand from "./ProductBrand";
import { Rating } from "@mantine/core";
import PureHtml from "../../custom/PureHtml";
import AddonsSlider from "./AddonsSlider";
import ProductForm from "@/components/product/ProductPage/ProductForm";
import ProductExtras from "./ProductExtras";
import ProductHighs from "@/components/product/ProductPage/ProductHighs";
import EarnPointsBadge from "@/components/EarnPointsBadge";
export default function ProductInfo(t0) {
  const $ = _c(44);
  const {
    product,
    addons,
    selectedOptions,
    setSelectedOptions,
    selectedVariant,
    setSelectedVariant,
    quantity,
    setQuantity,
    labelMap,
    labels
  } = t0;
  let t1;
  if ($[0] !== labels || $[1] !== product || $[2] !== selectedVariant) {
    t1 = <ProductGallery product={product} labels={labels} selectedVariant={selectedVariant} />;
    $[0] = labels;
    $[1] = product;
    $[2] = selectedVariant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== product.title) {
    t2 = <h1 className="text-xl lg:text-3xl">{product.title}</h1>;
    $[4] = product.title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== product) {
    t3 = <ProductBrand product={product} />;
    $[6] = product;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = product?.reviews_avg_rating || 0;
  let t5;
  if ($[8] !== t4) {
    t5 = <Rating value={t4} fractions={2} readOnly={true} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== product.reviews_count) {
    t6 = <span className="ms-2 text-slate-600">{product?.reviews_count ? <span>{product.reviews_count} {product.reviews_count > 1 ? "Reviews" : "Review"}</span> : <span>No Reviews yet</span>}</span>;
    $[10] = product.reviews_count;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="reviews flex items-center mb-1 gap-1">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== product.short_description) {
    t8 = product?.short_description?.trim().length && <PureHtml html={product?.short_description} />;
    $[15] = product.short_description;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== product) {
    t9 = product?.highs && <ProductHighs product={product} />;
    $[17] = product;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== product || $[20] !== quantity || $[21] !== selectedOptions || $[22] !== selectedVariant || $[23] !== setQuantity || $[24] !== setSelectedOptions || $[25] !== setSelectedVariant) {
    t10 = <ProductForm product={product} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} selectedVariant={selectedVariant} setSelectedVariant={setSelectedVariant} quantity={quantity} setQuantity={setQuantity} />;
    $[19] = product;
    $[20] = quantity;
    $[21] = selectedOptions;
    $[22] = selectedVariant;
    $[23] = setQuantity;
    $[24] = setSelectedOptions;
    $[25] = setSelectedVariant;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== product) {
    t11 = <ProductExtras product={product} />;
    $[27] = product;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== addons || $[30] !== labelMap) {
    t12 = <AddonsSlider addons={addons} labelMap={labelMap} />;
    $[29] = addons;
    $[30] = labelMap;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t2 || $[36] !== t3 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t13 = <div className="col-span-12 lg:col-span-6">{t2}{t3}{t7}{t8}{t9}{t10}{t11}{t12}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t2;
    $[36] = t3;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t1 || $[42] !== t13) {
    t14 = <div><div className="grid grid-cols-12 gap-4">{t1}{t13}</div></div>;
    $[41] = t1;
    $[42] = t13;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  return t14;
}